import React from "react";
import { InputAnswerAreaForLetters } from "./StyledComponent";

// JSON.parse protégé : une consigne non-JSON ne doit pas crasher le rendu.
const safeParse = (v) => { try { return JSON.parse(v); } catch { return null; } };

const WordToNumbers = ({ item, consigneValues, setConsigneValues }) => {
    return (
        <div className="flex flex-row flex-wrap gap-3 justify-center">
            {item?.consigne?.map((consigneItem, index) => (
                <div key={index} className="flex flex-col items-center gap-2">
                    <p className="font-bold text-lg">
                        {safeParse(consigneItem)?.value || "Valeur manquante"}
                    </p>
                    <InputAnswerAreaForLetters
                        value={consigneValues[index]?.userValue || ""}
                        onChange={(e) => {
                            const updatedValues = [...consigneValues];
                            updatedValues[index] = { ...updatedValues[index], userValue: e.target.value };
                            setConsigneValues(updatedValues);
                        }}
                        placeholder="Votre réponse"
                    />
                </div>
            ))}
        </div>
    );
};

export default WordToNumbers;
